export const areEqual = (obj1: any, obj2: any): boolean => {
	const obj1String: string = JSON.stringify(obj1);
	const obj2String: string = JSON.stringify(obj2);
	return obj1String === obj2String;
};
